import React from 'react'
import {
  MobileMenuHeaderLeft,
  MobileMenuHeaderRight,
  MobileMenuHeaderStyled,
  MobileMenuTitle,
} from './MobileMenuHeader.styled'
import { CQEssentialsLogoMobile } from 'Assets/icons/CQEssentialsLogoMobile'
import { XButton } from 'Assets/icons/XButton'
import { Humburger } from 'Assets/icons/Humburger'
import { useLocation } from 'react-router-dom'
import { IconButton } from 'Components/Elements/IconButton/IconButton.styled'
import { useAppStore } from 'Stores/appStoreModuleFed'

export const MobileMenuHeader = () => {
  const isMobileMenuOpen = useAppStore((state) => state.isMobileMenuOpen)
  const toggleMobileMenu = useAppStore((state) => state.toggleMobileMenu)
  const { pathname } = useLocation()
  const currentPage = () => {
    return pathname.substring(1)
  }

  return (
    <MobileMenuHeaderStyled>
      <MobileMenuHeaderLeft>
        <CQEssentialsLogoMobile />
        <MobileMenuTitle>{currentPage()}</MobileMenuTitle>
      </MobileMenuHeaderLeft>
      <MobileMenuHeaderRight>
        <IconButton
          onClick={() => toggleMobileMenu(!isMobileMenuOpen)}
          aria-label="close"
          css={{ width: '24px', right: '24px' }}
        >
          {isMobileMenuOpen ? <XButton /> : <Humburger />}
        </IconButton>
      </MobileMenuHeaderRight>
    </MobileMenuHeaderStyled>
  )
}
